<template>
  <v-tooltip bottom content-class="tooltip-bottom">
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        small
        :disabled="disabled"
        :loading="loading"
        :data-testid="dataTestid"
        @click="$emit('click', $event)"
      >
        <img :src="iconSrc" :alt="tooltip" class="notification-action-icon__img" />
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'NotificationActionIcon',
  props: {
    tooltip: { type: String, required: true },
    iconSrc: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    dataTestid: { type: String, default: 'notification-action-icon' },
  },
};
</script>

<style lang="scss" scoped>
@import './NotificationActionIcon.scss';
</style>
